(function () {
  if (window.__videoFullscreenNativeLoaded) return;
  window.__videoFullscreenNativeLoaded = true;

  function findCard(btn) {
    return (
      btn.closest('.collapsible-card-grid__card') ||
      btn.closest('.social-proof__card') ||
      btn.closest('article, .swiper-slide, [data-vcc-card]') ||
      btn.parentElement
    );
  }

  function findVideo(card) {
    if (!card) return null;
    var activeSlide = card.querySelector('.swiper-slide-active video');
    if (activeSlide) return activeSlide;
    var d = window.matchMedia('(min-width: 750px)').matches;
    var sel = d ? 'video.--d' : 'video.--m';
    return card.querySelector(sel) || card.querySelector('video');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-vcc-fullscreen]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var v = findVideo(findCard(btn));
    if (!v) return;
    if (v.requestFullscreen) {
      v.requestFullscreen();
    } else if (v.webkitRequestFullscreen) {
      v.webkitRequestFullscreen();
    } else if (v.webkitEnterFullscreen) {
      v.webkitEnterFullscreen();
    }
  }, true);
})();
